import { StyleSheet, Text, View } from 'react-native';
import { calcSizeForDevice, getResponsiveSize } from 'utils/index';
import { Platform } from 'utils/platform';

type ProfileSectionItemProps = {
  label: string;
  children?: React.ReactNode;
};

export function ProfileSectionItem({ label, children }: ProfileSectionItemProps) {
  return (
    <View style={[styles.field, Platform.isTV ? styles.tvField : styles.webField]}>
      <Text style={[styles.label, Platform.isTV ? styles.tvLabel : styles.webLabel]}>{label}</Text>
      {children}
    </View>
  );
}

const styles = StyleSheet.create({
  field: {
    width: '100%',
    flexDirection: 'column',
  },
  tvField: {
    marginBottom: calcSizeForDevice(24),
  },
  webField: {
    marginBottom: Number(getResponsiveSize({ base: 16, md: 24 })),
  },
  label: {
    fontWeight: '600',
    color: '#7A8CFF',
  },
  tvLabel: {
    fontSize: calcSizeForDevice(20),
    marginBottom: calcSizeForDevice(16),
  },
  webLabel: {
    fontSize: Number(getResponsiveSize({ base: 18, md: 20 })),
    marginBottom: Number(getResponsiveSize({ base: 12, md: 16 })),
  },
});
